import { ArrowUpRight } from '@phosphor-icons/react';

export const inputCls =
  'w-full border border-line bg-surface px-4 py-3 text-base sm:text-sm text-parchment placeholder:text-steel/40 transition-colors duration-200 focus:border-volt focus:outline-none';

export const Field = ({ label, htmlFor, children, hint }) => (
  <div>
    <label htmlFor={htmlFor} className="mono-label mb-2 block text-steel">
      {label}
    </label>
    {children}
    {hint && <p className="mt-1.5 text-xs text-steel/60">{hint}</p>}
  </div>
);

export const VoltButton = ({ children, className = '', ...props }) => (
  <button
    {...props}
    className={`group flex items-center justify-center gap-2 bg-volt px-6 py-3.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-ink transition-transform duration-200 hover:-translate-y-0.5 hover:bg-voltdark disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 ${className}`}
  >
    {children}
    <ArrowUpRight size={14} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </button>
);

export const SuccessPanel = ({ testId, title, lines }) => (
  <div data-testid={testId} className="border border-volt/40 bg-surface p-10 text-center sm:p-14">
    <span className="mx-auto mb-6 flex h-12 w-12 items-center justify-center bg-volt font-display text-xl font-black text-ink">✓</span>
    <h3 className="font-display text-2xl font-black tracking-tight text-parchment sm:text-3xl">{title}</h3>
    <div className="mx-auto mt-4 max-w-md space-y-2 text-sm leading-relaxed text-steel">
      {lines.map((l, i) => (
        <p key={i}>{l}</p>
      ))}
    </div>
  </div>
);
